"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _definitionhelpers = require("../../../utils/definitionhelpers");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// utils

/* ++++++++++ --------------- SAVE BUTTON: DEFINITION --------------- ++++++++++ */


var _default2 = {
  name: 'SaveButton',
  group: _definitionhelpers.groupNames.ctas,
  props: {
    removeIcon: {
      type: 'boolean',
      default: false,
      options: [true, false]
    },
    handleSave: {
      type: 'function',
      default: function _default() {
        return console.log('saving');
      }
    },
    variant: {
      type: 'string',
      default: 'action',
      options: ['action', 'primary', 'secondary', 'system', 'supporting']
    },
    buttonText: {
      type: 'object',
      default: 'Save'
    },
    savingData: {
      type: 'boolean',
      default: false,
      options: [true, false]
    },
    disabled: {
      type: 'boolean',
      default: false,
      options: [true, false]
    }
  }
};
exports.default = _default2;